import React from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
// ..
AOS.init();

const Skills = () => {

    return (
        <div className='mt-20 bg-about'>
            <div className='p-10'>
                <span className='flex justify-start items-center'>
                    <p className='text-white font-bold'>Skills</p>
                    <div className='h-[2px] ml-4 lg:w-96  w-2/4 bg-green-600'></div>
                </span>
                {/* skills  */}

                <div className='mt-10 lg:flex justify-between gap-10'>
                    <div className='bg-card p-5 mt-10 w-full'>
                        <li className='mt-3' data-aos="fade-right">
                            <p className='text-white font-bold'>HTML</p>
                            <div class="w-full bg-white">
                                <div class="bg-green-600 text-xs font-fold text-blue-100 text-center p leading-none w-[100%]">100%</div>
                            </div>
                        </li>
                        <li className='mt-3' data-aos="fade-right">
                            <p className='text-white font-bold'>CSS</p>
                            <div class="w-full bg-white">
                                <div class="bg-green-600 text-xs font-fold text-blue-100 text-center p leading-none w-[80%]">80%</div>
                            </div>
                        </li>
                        <li className='mt-3 data-aos="fade-right"'>
                            <p className='text-white font-bold'>Bootstrap</p>
                            <div class="w-full bg-white">
                                <div class="bg-green-600 text-xs font-fold text-blue-100 text-center p leading-none w-[80%]">80%</div>
                            </div>
                        </li>
                        <li className='mt-3' data-aos="fade-right">
                            <p className='text-white font-bold'>JavaScript</p>
                            <div class="w-full bg-white">
                                <div class="bg-green-600 text-xs font-fold text-blue-100 text-center p leading-none w-[75%]">70%</div>
                            </div>
                        </li>
                        <li className='mt-3' data-aos="fade-right">
                            <p className='text-white font-bold'>React</p>
                            <div class="w-full bg-white">
                                <div class="bg-green-600 text-xs font-fold text-blue-100 text-center p leading-none w-[75%]">70%</div>
                            </div>
                        </li>
                    </div>
                    {/* backend */}
                    <div className='bg-card p-5 mt-10 w-full'>
                        <li className='mt-3' data-aos="fade-right">
                            <p className='text-white font-bold'>Tailwind</p>
                            <div class="w-full bg-white">
                                <div class="bg-green-600 text-xs font-fold text-blue-100 text-center  leading-none w-[100%]">100%</div>
                            </div>
                        </li>
                        <li className='mt-3' data-aos="fade-right">
                            <p className='text-white font-bold'>Material UI</p>
                            <div class="w-full bg-white">
                                <div class="bg-green-600 text-xs font-fold text-blue-100 text-center p leading-none w-[75%]">70%</div>
                            </div>
                        </li>
                        <li className='mt-3'>
                            <p className='text-white font-bold' data-aos="fade-right">Node js</p>
                            <div class="w-full bg-white">
                                <div class="bg-green-600 text-xs font-fold text-blue-100 text-center p leading-none w-[95%]">95%</div>
                            </div>
                        </li>
                        <li className='mt-3' data-aos="fade-right">
                            <p className='text-white font-bold'>Mongodb</p>
                            <div class="w-full bg-white">
                                <div class="bg-green-600 text-xs font-fold text-blue-100 text-center p leading-none w-[80%]">80%</div>
                            </div>
                        </li>
                        <li className='mt-3' data-aos="fade-right">
                            <p className='text-white font-bold'>Express</p>
                            <div class="w-full bg-white">
                                <div class="bg-green-600 text-xs font-fold text-blue-100 text-center p leading-none w-[80%]">80%</div>
                            </div>
                        </li>

                    </div>
                </div>
                {/* ------------------------------------------------------------------------- */}

            </div>
        </div>
    );
};

export default Skills;